import PaymentMethod from 'ageas-react-component-modulo-pagamentos'

import { ENV } from '../../Environment'
import { MainContainer } from '../../GlobalStyles'
import { useContextStore } from '../../Stores/contextStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useFirstReceiptInfo } from '../../Stores/useFirstReceiptInfo'
import { API_ROUTES } from '../../constants/apiRoutes'
import { t } from '../../i18n'
import { generateTraceparent } from '../../utils/generateTraceparent'
import { getCookie } from '../../utils/getCookies'
import { Title } from '../AnimalInsuranceTable/styles'
import { PaymentMethodContainer, PaymentMethodTitle } from './styles'

type PaymentOptionsProps = {
  resetPaymentMethod?: (value: boolean) => void
}

const PAYMENT_REQUEST_ERROR = 'ServiceCallError'

export const PaymentOptions = ({ resetPaymentMethod }: PaymentOptionsProps) => {
  const { globalContext } = useContextStore()
  const { firstReceiptInfo } = useFirstReceiptInfo()
  const { quoteId } = useSimulatorStore()
  const username = getCookie('pts_username')
  const authCookies = getCookie('auth')

  return (
    <MainContainer>
      <PaymentMethodTitle>
        <Title>{t('pages.step7.firstReceipt')}</Title>
      </PaymentMethodTitle>
      <PaymentMethodContainer>
        <div>
          <PaymentMethod
            id="paymentsComponentConfirmation"
            key="paymentsComponentConfirmation"
            loaderStyle="miniLoader"
            version="3" // Para este componente, é necessário passar o version=3
            colorTheme="blue"
            token={authCookies}
            simulationNumber={quoteId}
            receiptNumber={firstReceiptInfo?.invoiceId}
            bsWebmethodGet={API_ROUTES.payment.get}
            bsWebmethodPut={API_ROUTES.payment.put}
            bsWebmethodShare={API_ROUTES.payment.share}
            bsWebService={API_ROUTES.payment.service}
            traceparent={generateTraceparent()}
            errorFeedback
            onValueChanged={(data: any) => {
              if (data === PAYMENT_REQUEST_ERROR && resetPaymentMethod) {
                resetPaymentMethod(true)
              }
            }}
            referenceDocument={firstReceiptInfo?.invoiceId}
            paymentListMaxRetry={ENV().PaymentListMaxRetry} // 3 (DEVOPS)
            paymentListRetryTimer={Number(ENV().PaymentListRetryTimer)} // 5000 (DEVOPS)
            apimUrl={ENV().BaseUrl}
            aipHeaders={{
              'aip-SubscriptionKey': ENV().SubscriptionKey,
              'aip-Company': ENV().Company,
              'aip-Brand': ENV().Brand,
              'aip-Channel': ENV().Payment.channel,
              'aip-Country': ENV().Country,
              'aip-Language': ENV().Language,
              'aip-currency': ENV().Currency,
              'aip-user': username || globalContext.username,
            }}
            aipPayloadBody={{
              firstReceiptId: firstReceiptInfo?.invoiceId,
            }}
          />
        </div>
      </PaymentMethodContainer>
    </MainContainer>
  )
}
